<template>
	<ListItem is-recipient>
		<template #text>
			<div v-if="hasCompleteVita">
				<b>Möchtest du deinen Lebenslauf senden?</b>
			</div>
			<div v-else>
				<div v-if="vitaFile">
					<b>Dein Lebenslauf wurde erfolgreich hochgeladen.</b>
					<div class="message-list--item-vita-upload mt-3">
						<div>
							<Icon icon="vita"/>
						</div>
						<div>{{ vitaFile.name }}</div>
						<div>
							<a href="#" @click.prevent="removeVitaFile">
								<Icon icon="close"/>
							</a>
						</div>
					</div>
				</div>
				<div v-else-if="!hasCompleteVita && hasUploadedVita">
					<div>
						<b>Dein skilldoo-Lebenslauf ist noch nicht vollständig.</b>
					</div>
					<div class="mt-2">Benutze deinen bereits hochgeladenen Lebenslauf:</div>
					<div class="message-list--item-vita-upload mt-3">
						<div>
							<Icon icon="vita"/>
						</div>
						<div>
							<a :href="vitaUrl" target="_blank">{{ vitaInfo.documentName }}</a>
						</div>
						<div>
							<a href="#" @click.prevent="openUploadPrompt">
								<Icon icon="edit"/>
							</a>
							<a href="#" @click.prevent="$emit('deleteDocument')">
								<Icon icon="close"/>
							</a>
						</div>
					</div>
					<div class="mt-2">...oder noch besser - Vervollständige deinen skilldoo-Lebenslauf:</div>
					<div class="mt-2">
						<Button
							text="Lebenslauf vervollständigen"
							icon="caret-right"
							:href="profileVitaUrl"
							smaller
						/>
					</div>
				</div>
				<template v-else>
					<b>Dein skilldoo-Lebenslauf ist noch nicht vollständig.</b>
					<p>Steigere deine Chancen und verwende den skilldoo-Lebenslauf, der von Personalexperten entwickelt wurde. 1x schnell ausfüllen, immer verwenden.</p>
					<div class="d-flex align-items-center flex-column flex-md-row mt-3">
						<Button
							text="Lebenslauf vervollständigen"
							icon="caret-right"
							:href="profileVitaUrl"
							smaller
						/>
						<div class="ml-0 ml-md-2 mt-2 mt-md-0">
							<a href="#" class="color-turquoise" @click="openUploadPrompt">Lebenslauf hochladen</a>
						</div>
					</div>
				</template>
				<input
					type="file"
					ref="vitaUpload"
					:accept="acceptedMimeTypes"
					class="d-none"
					@change="vitaFileChanged"
				/>
			</div>
		</template>
	</ListItem>
</template>

<script>
import ListItem from "@/vue/communication/conversation/message/ListItem.vue";
import Button from "@/vue/common/Button.vue";
import Upload from "@/vue/legitimation/identification/Upload.vue";
import Icon from "@/vue/icon/Icon.vue";
import {toBase64} from "@/helper/File";
import ConfirmPopUp from "@/vue/common/popup/ConfirmPopUp.vue";

export default {
	components: {ConfirmPopUp, Icon, Upload, Button, ListItem},

	props: {
		conversation: {
			type: Object,
			required: true
		},
		vitaInfo: {
			type: Object,
			required: true
		},
	},

	mounted ()
	{
		this.emitChangeEvent();
	},

	data ()
	{
		return {
			vitaFile: undefined,
			hasDocument: this.vitaInfo.hasDocument,
		};
	},

	computed: {
		vitaUrl ()
		{
			return '/kommunikation/abstimmung/' + this.conversation.id + '/lebenslauf/' + this.vitaInfo.documentName;
		},
		profileVitaUrl ()
		{
			return '/kandidat/profil/lebenslauf';
		},
		acceptedMimeTypes ()
		{
			return [
				'image/*', // images
				'application/pdf', // pdf
				'text/pdf', // pdf
				'application/msword', // doc
				'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // docx
				'application/vnd.ms-powerpoint', // ppt
				'application/vnd.openxmlformats-officedocument.presentationml.presentation' // pptx
			].join(', ');
		},
		hasUploadedVita ()
		{
			return this.hasDocument;
		},
		hasCompleteVita ()
		{
			return this.vitaInfo.complete;
		}
	},

	methods: {
		openUploadPrompt ()
		{
			this.$refs.vitaUpload.click();
		},
		vitaFileChanged (e)
		{
			this.vitaFile = e.target.files[0];

			this.emitChangeEvent();
		},
		removeVitaFile ()
		{
			this.vitaFile = undefined;

			this.$refs.vitaUpload.value = '';

			this.emitChangeEvent();
		},
		async emitChangeEvent ()
		{
			if(this.vitaFile)
			{
				this.$emit('input', {
					uploadedFile: {
						name: this.vitaFile.name,
						mimeType: this.vitaFile.type,
						size: this.vitaFile.size,
						base64: (await toBase64(this.vitaFile))
					}
				});

				return;
			}

			if (this.hasCompleteVita || this.hasUploadedVita)
			{
				this.$emit('input', {
					vitaExists: true
				});

				return;
			}

			this.$emit('input', undefined);
		}
	}
}
</script>
